import { Component, forwardRef, input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-form-switch',
  standalone: true,
  templateUrl: './form-switch.component.html',
  styleUrl: './form-switch.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormSwitchComponent),
      multi: true,
    },
  ],
})
export class FormSwitchComponent implements ControlValueAccessor {
  activeLabel = input('Activo');
  inactiveLabel = input('Inactivo');
  helperLabel = input('');
  ariaLabel = input('Cambiar estado');

  checked = false;
  disabled = false;

  private onChange = (_value: boolean) => {};
  private onTouched = () => {};

  get statusLabel(): string {
    return this.checked ? this.activeLabel() : this.inactiveLabel();
  }

  toggle(): void {
    if (this.disabled) return;

    this.checked = !this.checked;
    this.onChange(this.checked);
    this.onTouched();
  }

  writeValue(value: boolean | null): void {
    this.checked = !!value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
